import React from 'react';
import MemberDetail from './index';

const MemberRegenerativeMedicineOps: React.FC = () => {
  return <MemberDetail section="regenerative-medicine-ops" />;
};

MemberRegenerativeMedicineOps.displayName = 'MemberRegenerativeMedicineOps';

export default MemberRegenerativeMedicineOps;
